/**
 * SettingsShortcut — dezentes Zahnrad-Icon (Task G, Jun-2026).
 *
 * Springt direkt in die zugehörigen Einstellungen (Deep-Link mit Hash, der von
 * DashboardSettings.jsx ausgewertet wird). Sichtbar NUR für den Händler-Hauptsitz
 * (b2b, kein Filial-Konto) — Filialen & Mitarbeiter sehen den Shortcut nicht.
 */
import { Link } from "react-router-dom";
import { Settings } from "lucide-react";
import { useAuth } from "../../lib/auth";
import { useGearsVisible } from "../../lib/gearVisibility";

export function SettingsShortcut({ to, title = "Zu den Einstellungen", testid = "settings-shortcut", dark = false }) {
    // Aug-2026 (User-Wunsch): Zahnräder nur für Admin + freigegebene Accounts.
    const gearsOk = useGearsVisible();
    const { user } = useAuth();
    if (!gearsOk) return null;
    const isHauptsitz = !!user && user !== false && user.role === "b2b" && user.branch_role !== "filiale";
    if (!isHauptsitz) return null;
    const tone = dark
        ? "text-gray-400 hover:text-white hover:bg-white/10"
        : "text-gray-400 hover:text-[#111827] hover:bg-gray-100";
    return (
        <Link
            to={to}
            title={title}
            aria-label={title}
            data-testid={testid}
            className={`inline-flex items-center justify-center w-7 h-7 rounded-sm transition-colors shrink-0 ${tone}`}
        >
            <Settings className="w-4 h-4" />
        </Link>
    );
}

export default SettingsShortcut;
